import styled from 'styled-components';
import { OpoCaseStatus } from '@nkr/models/opo-case';
import { opoCardStyles, opoTableStyles } from '../landing-page/opo-styles';

export const CaseTableCard = styled.div`
    ${opoCardStyles}

    overflow: visible;

    & > .table {
        margin-bottom: 0;
        border-collapse: separate;
        border-spacing: 0;
        ${opoTableStyles}
    }

    & > .table > thead > tr > th:first-child {
        border-top-left-radius: 11px;
    }

    & > .table > thead > tr > th:last-child {
        border-top-right-radius: 11px;
    }

    & > .table > tbody > tr:first-child > td {
        border-top: none !important;
    }

    & > .table > tbody > tr:last-child > td:first-child {
        border-bottom-left-radius: 11px;
    }

    & > .table > tbody > tr:last-child > td:last-child {
        border-bottom-right-radius: 11px;
    }

    & > .table > thead > tr > th,
    & > .table > tbody > tr > td {
        text-align: center;
    }

    & > .table > tbody > tr > td[colspan] {
        padding: 24px 16px !important;
        color: #6B7A8F;
        font-size: 14px !important;
    }

    & > .table > tbody > tr > td > .btn-group > .dropdown-menu {
        min-width: 180px;
        padding: 6px;
        border: 1px solid #E3E8EF;
        border-radius: 10px;
        box-shadow: 0 8px 24px rgba(16, 24, 40, 0.12);
    }

    & > .table > tbody > tr > td > .btn-group > .dropdown-menu > li > a {
        padding: 6px 10px;
        border-radius: 6px;
        color: #3A4756;
        font-size: 13px;
    }

    & > .table > tbody > tr > td > .btn-group > .dropdown-menu > li > a:hover {
        background-color: #F3F5F8;
        color: #16365A;
    }

    & > .table > tbody > tr > td > .btn-group > .dropdown-menu > li.danger > a {
        color: #C9302C;
    }
`;

const statusColors = {
    [OpoCaseStatus.Pending]: { background: '#EEF3F9', color: '#16365A' },
    [OpoCaseStatus.Completed]: { background: '#E6F4EA', color: '#2E7D32' },
    [OpoCaseStatus.Cancelled]: { background: '#F3F5F8', color: '#6B7A8F' }
};

export const StatusPill = styled.span<{ $status: OpoCaseStatus }>`
    display: inline-block;
    padding: 2px 10px;
    border-radius: 999px;
    background-color: ${p => statusColors[p.$status].background};
    color: ${p => statusColors[p.$status].color};
    font-size: 12px;
    font-weight: 600;
`;

export const centerSelectStyles = (hasError: boolean) => ({
    control: (provided: any, state: any) => ({
        ...provided,
        minHeight: 32,
        borderRadius: 8,
        borderColor: hasError ? '#A3201A' : (state.isFocused ? '#337AB7' : '#D5DBE3'),
        boxShadow: state.isFocused ? `0 0 0 3px ${hasError ? 'rgba(163, 32, 26, 0.18)' : 'rgba(51, 122, 183, 0.15)'}` : 'none',
        fontSize: 14,
        '&:hover': {
            borderColor: hasError ? '#A3201A' : (state.isFocused ? '#337AB7' : '#B8C2CF')
        }
    }),
    valueContainer: (provided: any) => ({ ...provided, padding: '0 10px' }),
    input: (provided: any) => ({ ...provided, margin: 0, padding: 0, color: '#1F2A37' }),
    singleValue: (provided: any) => ({ ...provided, color: '#1F2A37' }),
    placeholder: (provided: any) => ({ ...provided, color: '#8A97A8' }),
    indicatorSeparator: () => ({ display: 'none' }),
    dropdownIndicator: (provided: any) => ({ ...provided, padding: '0 8px', color: '#8A97A8' }),
    clearIndicator: (provided: any) => ({ ...provided, padding: '0 4px', color: '#8A97A8' }),
    menuPortal: (provided: any) => ({ ...provided, zIndex: 1100 }),
    menu: (provided: any) => ({
        ...provided,
        marginTop: 4,
        borderRadius: 10,
        border: '1px solid #E3E8EF',
        boxShadow: '0 8px 24px rgba(16, 24, 40, 0.12)',
        overflow: 'hidden'
    }),
    menuList: (provided: any) => ({ ...provided, padding: 6 }),
    option: (provided: any, state: any) => ({
        ...provided,
        borderRadius: 6,
        fontSize: 12,
        cursor: 'pointer',
        backgroundColor: state.isSelected ? '#EEF3F9' : (state.isFocused ? '#F3F5F8' : 'transparent'),
        color: state.isSelected ? '#16365A' : '#3A4756',
        fontWeight: state.isSelected ? 600 : 400,
        paddingTop: 5,
        paddingBottom: 5
    })
});
